export enum COLOR {
  BLACK_100 = "var(--oc-base-color-black-100, #212121)",
  WHITE = "var(--oc-base-color-white, #ffffff)",
  RED_100 = "var(--oc-base-color-otto-red-100, #f00020)",
  GRAY_400 = "var(--oc-base-color-gray-400, #6d6d6d)",
}